import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { BlockApi } from "../../../../Shared/Constants/api";
import { getBlockCreationObject } from "../Data/BlockWrappers";

export const createBlockApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${BlockApi}`,
      getBlockCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
